import React from "react";
import { CCEmptyState } from "@pymblecitizencoders/cc-ui";
import { app } from "../config";
import "./eventManager/eventManager.css";

const AccessDenied: React.FC = () => {
	return (
		<div className="em-page" data-surface="page">
			<div className="em-container em-container--narrow">
				<div className="em-panel em-notice-panel" data-surface="card">
					<CCEmptyState
						message={`You do not have permission to access the ${app.name}.`}
						description="This application is available to active staff only. Please contact your system administrator if you believe you should have access."
					/>
				</div>
			</div>
		</div>
	);
};

export default AccessDenied;
